import { render, staticRenderFns } from "./WelcomePopupV3.vue?vue&type=template&id=193ac8f2&scoped=true&"
import script from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
export * from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePopupV3.vue?vue&type=style&index=0&id=193ac8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ac8f2",
  null
  
)

export default component.exports